<style>
.el-dialog {
    width: 50% !important;
}
</style>

<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}
.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}
.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
button[disabled='disabled'],
button:disabled {
    background-color: rgba(200, 200, 200, 2.3);
    border-color: rgba(200, 200, 200, 2.3);
    cursor: not-allowed;
}
.heading-cart {
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
}
.heading-cart a {
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    background: #222;
    color: #fff;
    border-radius: 30px;
    padding: 0 15px;
}
.heading-cart {
    margin-bottom: 0;
}
.box-body {
    padding: 0px 20px 20px;
}
.el-button.edit {
    padding: 5px 10px;
}
.active-button {
    padding: 3px;
    margin: auto;
    float: none;
    display: block;
    position: relative;
    top: -35px;
}
.select-items p {
    margin-top: 0.75rem;
    margin-bottom: 0;
}
.target-section,
.dom-section {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.75rem;
}
.target-section .el-select {
    flex: 0.3;
}
.target-section div, .dom-section div {
    display: flex;
    flex-direction: column;
}

.target-section div p, .dom-section div p {
    margin: 0;
}
.fields-section div {
    display: flex;
    flex: 1;
}
.save-section {
    text-align: right;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border heading-cart">
                    <h3 class="box-title">New Layouts</h3>
                    <el-dialog
                        class="element-promt"
                        title="Meta Tags"
                        :visible.sync="dialogVisible"
                        width="30%"
                        :before-close="handleClose"
                    >
                        <el-input type="textarea" :rows="10" v-model="metaCopy"></el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
                        </span>
                    </el-dialog>
                    <el-button
                        type="text"
                        @click="dialogVisible = true"
                        class="el-button el-button--info pull-right"
                        v-clipboard:copy="metaCopy"
                    >
                        <svg
                            aria-hidden="true"
                            width="16px"
                            height="16px"
                            data-prefix="fal"
                            data-icon="copy"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            class="svg-inline--fa fa-copy fa-w-14"
                            style="font-size: 48px"
                        >
                            <path
                                fill="currentColor"
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
                                class=""
                            ></path></svg
                        >&nbsp; Copy Meta
                    </el-button>
                </div>

                <div class="box-body">
                    <el-table
                        :data="existingLayouts"
                        height="300"
                        stripe
                        style="width: 100%; border-spacing: 0"
                        v-loading="loading"
                    >
                        <el-table-column label="Layout name" width="420" prop="layout_name">
                            <template slot-scope="props">
                                <span>{{ props.row.layout_name }}</span>

                                <br />
                                <el-dropdown trigger="click" class="see-usage" @command="OpenLayoutUsage">
                                    <span class="el-dropdown-link">
                                        See usage in bucket<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="{
                                                alias: props.row.layout_name,
                                                bucket_id: bucket.id,
                                                id: props.row.id,
                                            }"
                                            v-for="bucket in domain_details.buckets"
                                            :key="bucket.id"
                                        >
                                            <span>{{ bucket.name }}</span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <br />
                            </template>
                        </el-table-column>
                        <el-table-column label="Layout type" width="200" prop="type">
                            <template slot-scope="props">
                                <p>{{ props.row.type }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Active">
                            <template slot-scope="props">
                                <div v-if="props.row.is_active">
                                    <svg
                                        data-v-7a40f996=""
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="far"
                                        data-icon="check-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            data-v-7a40f996=""
                                            fill="green"
                                            d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                        ></path>
                                    </svg>
                                </div>
                                <div v-if="!props.row.is_active">
                                    <svg
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="fal"
                                        data-icon="times-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            fill="red"
                                            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                            class=""
                                        ></path>
                                    </svg>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Edit" width="80">
                            <template slot-scope="props">
                                <button
                                    class="el-button btn-rounded el-button--success edit"
                                    @click="editLayout(props.row)"
                                >
                                    <i class="ti-pencil"></i>
                                </button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <form method="post" v-on:submit.prevent="saveLayout" class="form">
                        <div class="row">
                            <div class="col-md-8">
                                <h5>Layout name</h5>
                                <el-input
                                    class="publisher-input"
                                    name="selector"
                                    type="text"
                                    placeholder="layout name"
                                    v-model="layoutForm.layoutName"
                                ></el-input>
                            </div>
                        </div>
                        <div v-if="domain_details.features && (domain_details.features['advance_layouts']=='enabled')">
                            <div class="row">
                                <div class="col-md-8 select-items">
                                    <p class="form-label">Layout Type</p>
                                    <el-radio-group v-model="layoutForm.layoutType" size="small" v-on:change="changeLayout">
                                        <el-radio-button label="default" value="default">Default</el-radio-button>
                                        <el-radio-button label="url" value="url">URL</el-radio-button>
                                        <el-radio-button label="dom" value="dom">DOM</el-radio-button>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="row fields-section">
                                <div v-if="layoutForm.layoutType === 'dom'" class="dom-section col-md-8">
                                    <div>
                                        <p class="form-label">DOM Selector String</p>
                                    <el-input
                                        class="publisher-input"
                                        name="selector"
                                        type="text"
                                        placeholder="DOM Selector String"
                                        v-model="layoutForm.selectorData.domSelectorString"
                                        required
                                    ></el-input>
                                    </div>
                                    <div>
                                        <p class="form-label">DOM Node Attribute</p>
                                    <el-input
                                        class="publisher-input"
                                        name="selector"
                                        type="text"
                                        placeholder="DOM Node Attribute"
                                        v-model="layoutForm.selectorData.domNodeAttribute"
                                        required
                                    ></el-input>
                                    </div>
                                    
                                </div>

                                <div class="target-section col-md-8" v-if="layoutForm.layoutType !== 'default'">
                                    <div>
                                        <p class="form-label">Operator</p>
                                        <el-select
                                            class="publisher-input select-input"
                                            collapse-tags
                                            filterable
                                            placeholder="Select"
                                            v-model="layoutForm.selectorData.operator"
                                            required
                                        >
                                            <el-option
                                                v-for="(option, index) in ['equals', 'contains']"
                                                :key="index"
                                                :label="option"
                                                :value="option"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                    
                                    <div>
                                        <p class="form-label">Value</p>
                                        <el-input
                                            class="publisher-input"
                                            name="selector"
                                            type="text"
                                            placeholder="Match String"
                                            v-model="layoutForm.selectorData.data"
                                            required
                                        ></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <h5>Active</h5>
                                <div class="m-t-5">
                                    <el-switch v-model="layoutForm.isActive" active-color="#13ce66"></el-switch>
                                </div>
                            </div>
                            <div class="col-md-12 save-section">
                                <button class="el-button el-button--secondary" type="button" @click="resetForm()">
                                    Reset
                                </button>
                                <button class="el-button el-button--success" type="submit">Save</button>
                            </div>
                        </div>
                    </form>
                    <el-pagination
                        style="text-align: center; margin-top: 30px"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="total_Pages"
                        layout="sizes, prev, pager, next"
                        :page-size="offset"
                    >
                    </el-pagination>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios';
import Vue from 'vue';
import VerEx from 'verbal-expressions';
Vue.forceUpdate;

export default {
    data() {
        return {
            currentPage: 1,
            offset: 10,
            total_Pages: 0,
            dialogVisible: false,
            domId: undefined,
            metaCopy: undefined,
            isEdit: false,
            layOutId: null,
            existingLayouts: [],
            existingAdSpots: [],
            formData: {
                index: -1,
                editId: undefined,
                existing: true,
                udivid: undefined,
                selector: undefined,
            },
            layoutForm: {
                layoutName: '',
                isActive: true,
                selectorData: {
                    data: '',
                    operator: '',
                    domSelectorString: '',
                    domNodeAttribute: '',
                },
                layoutType: 'default',
            },
            loading: true,
        };
    },
    props: {
        domain_details: Object,
    },
    watch: {
        $route(to, from) {
            this.loadLayoutsDataByCurrentPage(this.currentPage);
        },
    },
    created: function () {
        this.domId = this.$route.params.domId;
        // this.copyFormData = JSON.parse(JSON.stringify(this.formData));

        this.copyLayoutForm = JSON.parse(JSON.stringify(this.layoutForm));
        axios.all([axios.get(BASE_URL + 'v1/domains/' + this.domId + '/page-layouts/')]).then(
            axios.spread((pageLayouts) => {
                this.existingLayouts = pageLayouts.data;
                this.loading = false;
                this.total_Pages = Math.ceil(this.existingLayouts.length / this.offset);
                let i = 0,
                    j = 0;

                var k = 0;

                var layouts = '';
                for (k = 0; k < pageLayouts.data.length; k++) {
                    if (pageLayouts.data[k].is_active == true) {
                        layouts +=
                            'Layout Name: ' +
                            pageLayouts.data[k].layout_name +
                            '\nMeta Tag: <meta name="atdlayout" content="' +
                            pageLayouts.data[k].layout_name +
                            '">\n\n';
                    }
                }
                this.metaCopy =
                    'Instructions for publishers to insert layout metadata tags on their website.These are the layouts which are identified by the Automatad system. The respective meta tags will have to be inserted in the headers of each of the unique layouts mentioned below.\n\n' +
                    layouts;
            })
        );
    },
    methods: {
        handleClose(done) {
            this.$confirm('Are you sure to close this dialog?')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        open3() {
            this.$prompt('You can Copy Meta here', 'Copy Meta', {
                customClass: 'elementPromt',
                inputType: 'textarea',
                inputValue: this.metaCopy,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputErrorMessage: 'Invalid Email',
            })
                .then((value) => {
                    this.$message({
                        type: 'success',
                        message: 'Your email is:' + value,
                    });
                    console.log(value);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Input canceled',
                    });
                });
        },
        copyMeta() {
            conosle.log();
        },
        saveLayout() {
            if(!this.layoutForm.layoutName){
                this.$notify({
                    title: 'error',
                    message: 'Please enter layout name',
                    type: 'error',
                });
                return;
            }
            if(this.layoutForm.layoutType === 'url' && (!this.layoutForm.selectorData.data || !this.layoutForm.selectorData.operator)){
                this.$notify({
                    title: 'error',
                    message: 'Fields are mandatory',
                    type: 'error',
                });
                return;
            }
            else if(this.layoutForm.layoutType === 'dom' && (!this.layoutForm.selectorData.domSelectorString || !this.layoutForm.selectorData.domNodeAttribute || !this.layoutForm.selectorData.data || !this.layoutForm.selectorData.operator)){
                this.$notify({
                    title: 'error',
                    message: 'Fields are mandatory',
                    type: 'error',
                });
                return;
            }
            console.log('save click isActive', this.layoutForm.isActive);
            let request_data = {
                domain: parseInt(this.domId),
                layout_name: this.layoutForm.layoutName.toLowerCase(),
                is_active: this.layoutForm.isActive,
                type: this.layoutForm.layoutType,
            };
            if (this.layoutForm.layoutType !== 'default') {
                request_data['type'] = this.layoutForm.layoutType;
                var selectorDataPattern = this.convertObjToRegex();
                request_data['selector_data'] = {
                    pattern: selectorDataPattern,
                };
                if (this.layoutForm.layoutType === 'dom') {
                    request_data['selector_data'].dom_node_attribute = this.layoutForm.selectorData.domNodeAttribute;
                    request_data['selector_data'].dom_selector_string = this.layoutForm.selectorData.domSelectorString;
                }
            }
            if (this.isEdit) {
                console.log('save edit click isActive', this.layoutForm.isActive);
                const URL = BASE_URL + 'v1/domains/' + this.domId + '/page-layouts/' + this.layOutId + '/';

                axios.put(URL, request_data).then((response) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Layout has been edit successfully',
                        type: 'success',
                    });
                    this.isEdit = false;
                    for (var i = 0; i < this.existingLayouts.length; i++) {
                        if (this.existingLayouts[i].id == this.layOutId) {
                            this.existingLayouts.splice(i, 1, response.data);
                            break;
                        }
                    }
                    this.resetForm();
                    this.$forceUpdate();
                    this.currentPage = 1;
                });
            } else {
                console.log('save add isActive', this.layoutForm.isActive);
                console.log('isEdit in add', this.isEdit);
                axios.post(BASE_URL + 'v1/domains/' + this.domId + '/page-layouts/', request_data).then((response) => {
                    this.existingLayouts.splice(0, 0, response.data);
                    this.$notify({
                        title: 'Success',
                        message: 'Layout has been successfully created.',
                        type: 'success',
                    });
                    this.resetForm();
                    this.$forceUpdate();
                });
            }
        },
        editLayout(layout) {
            console.log('edit', layout);
            this.isEdit = true;
            this.layOutId = layout.id;
            this.layoutForm.layoutName = layout.layout_name;
            this.layoutForm.isActive = layout.is_active;
            this.layoutForm.layoutType = layout.type;
            this.isEdit = true;
            if (layout.type && layout.type !== 'default') {
                let obj = this.convertRegexToObj(layout.selector_data.pattern);
                this.layoutForm.selectorData.data = obj.data;
                this.layoutForm.selectorData.operator = obj.operator;
                this.layoutForm.selectorData.domSelectorString = layout.selector_data.dom_selector_string;
                this.layoutForm.selectorData.domNodeAttribute = layout.selector_data.dom_node_attribute;
            } else {
                let obj = this.copyLayoutForm.selectorData;
                this.layoutForm.selectorData.data = obj.data;
                this.layoutForm.selectorData.operator = obj.operator;
                this.layoutForm.selectorData.domSelectorString = obj.domSelectorString;
                this.layoutForm.selectorData.domNodeAttribute = obj.domNodeAttribute;
            }
            this.$forceUpdate();
        },
        resetForm() {
            this.layOutId = null;
            this.isEdit = false;
            this.layoutForm.layoutName = '';
            this.layoutForm.isActive = true;
            this.layoutForm.layoutType = 'default';
            this.layoutForm.selectorData.data = '';
            this.layoutForm.selectorData.operator = '';
            this.layoutForm.selectorData.domSelectorString = '';
            this.layoutForm.selectorData.domNodeAttribute = '';
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadLayoutsDataByCurrentPage(val);
        },
        handleSizeChange(val) {
            this.offset = val;
            this.loadLayoutsDataByCurrentPage(1);
            this.currentPage = 1;
        },
        OpenLayoutUsage(command) {
            setTimeout(() => {
                let url = `/admin/publisher/${this.$route.params.uuid}/domain/${this.domId}/buckets/${command.bucket_id}/fi/?adLayout=${command.id}`;
                this.$router.push(url);
            });
        },
        loadLayoutsDataByCurrentPage(pageNum = 1) {
            this.loading = true;
            axios
                .get(BASE_URL + `v1/domains/${this.domId}/page-layouts/?page=${pageNum}&&offset=${this.offset}`)
                .then((response) => {
                    this.existingLayouts = response.data;
                    this.total_Pages = response.data.length;
                    this.loading = false;
                });
        },
        convertObjToRegex() {
            var expression = '';
            if (this.layoutForm.selectorData.operator === 'equals') {
                expression = VerEx().add('^' + this.layoutForm.selectorData.data + '$');
            } else if (this.layoutForm.selectorData.operator === 'contains') {
                expression = VerEx().find(this.layoutForm.selectorData.data);
            }
            var expr = expression == '' ? '' : expression.toRegExp();
            return expr.toString().replace('/', '').replace('/gm', '');
        },
        convertRegexToObj(expr) {
            var regex_sanitize_expression = /[&\\#,+()!$~%.^'":*?<>{}]/g;
            if (expr.indexOf('^') > -1 && expr.indexOf('$') > -1) {
                return {
                    data: expr.replace(regex_sanitize_expression, ''),
                    operator: 'equals',
                };
            } else if (expr == '') {
                return { operator: 'equals', data: '' };
            }
            return { operator: 'contains', data: expr.replace(regex_sanitize_expression, '') };
        },
        changeLayout(){
            this.layoutForm.selectorData.data = "";
            this.layoutForm.selectorData.operator = "";
        },
    },
};
</script>



// WEBPACK FOOTER //
// Layout.vue?4c3919fa